import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getDatabase  } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyCTt7s0-27aZFMVJlxqiaZCiw5WPqujzJE",
  authDomain: "unlockcode.firebaseapp.com",
  databaseURL: "https://unlockcode-default-rtdb.firebaseio.com",
  projectId: "unlockcode",
  storageBucket: "unlockcode.appspot.com",
  messagingSenderId: "799100129156",
  appId: "1:799100129156:web:09045f1196ea345916d7d1"
};
  const app = initializeApp(firebaseConfig);
  export const Firestore_db = getFirestore(app);
  export const Realtime_db = getDatabase(app);